import './Signup.css';
import { useToggle } from '@mantine/hooks';
import { Anchor, Button, Container, Group, Image, Modal, Paper, PasswordInput, Stack, Text, TextInput, ThemeIcon } from '@mantine/core';
import Boompaylogo from '../Assets/Boompaylogo.png';
import { IconMail, IconPhoneCall } from '@tabler/icons-react';
import { useState } from 'react';
import { message } from 'antd';
import { jwtDecode } from 'jwt-decode';
import { useAuthContext } from '../Hooks/UseAuthContext';




const Signup = (PaperProps) => {
    const [type, toggle] = useToggle(['login', 'register']);
    const { dispatch } = useAuthContext();
    const [signup, setsignup] = useState({
        Authorized_Person_Name: '',
        Authorized_Person_Mobile_Number: '',
        Company_Email: '',
        Company_Name: '',
        Profile_Password: ''
    })
    const [forgotinput, setforgotinput] = useState({
        Company_Email: '',
        NewProfile_Password: ''
    })
    const [loading, setloading] = useState(false);
    const [forgotmodal, setForgotmodal] = useState(false);

    const handelChange = (e) => {
        const { name, value } = e.target;
        setsignup({ ...signup, [name]: value });
    }
    const handelforgotChange = (e) => {
        const { name, value } = e.target;
        setforgotinput({ ...forgotinput, [name]: value });
    }
    const handleSubmit = async () => {
        const { Authorized_Person_Name, Authorized_Person_Mobile_Number, Company_Email, Company_Name, Profile_Password } = signup;
        if (!Authorized_Person_Name || !Authorized_Person_Mobile_Number || !Company_Email || !Company_Name || !Profile_Password) {
            message.error('Please fill in all the fields');
            return;
        }
        if (Authorized_Person_Name.length < 3) {
            message.error('Authorized Person Name must be at least 3 characters long');
            return;
        }
        if (Authorized_Person_Mobile_Number.length < 10 || Authorized_Person_Mobile_Number.length > 10 || !/^\d{10}$/.test(Authorized_Person_Mobile_Number)) {
            message.error('Please enter a valid 10-digit mobile number');
            return;
        }
        if (!/^\S+@\S+\.\S+$/.test(Company_Email)) {
            message.error('Please enter a valid email address');
            return;
        }
        if (Company_Name.length < 3) {
            message.error('Company Name must be at least 3 characters long');
            return;
        }
        if (Profile_Password.length < 7 || !/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{7,}$/.test(Profile_Password)) {
            message.error('Password must be at least 7 characters long and contain at least one letter one special and one number');
            return;
        }
        setloading(true);
        try {
            const response = await fetch('https://api.boompay.in/signup-user', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(signup)
            });
            const data = await response.json();
            // console.log(data);
            if (response.status === 201) {
                message.success('Signup form successfully submitted. Please wait for verification.');
                setloading(false);
                setsignup({
                    Authorized_Person_Name: '',
                    Authorized_Person_Mobile_Number: '',
                    Company_Email: '',
                    Company_Name: '',
                    Profile_Password: ''
                })
            } else if (response.status === 400) {
                message.error(data.message);
                setloading(false);
            } else {
                message.error('Signup failed. Please try again later.');
                setloading(false);
            }
        } catch (error) {
            console.error('Error during signup:', error);
            message.error('An error occurred during signup. Please try again later.');
            setloading(false);
        }
    }
    const saveToken = (token) => {
        const decodedToken = jwtDecode(token); // Use jwt-decode library
        const expiryTime = decodedToken.exp * 1000; // Convert expiry time to milliseconds
        localStorage.setItem('user', token);
        localStorage.setItem('expiryTime', expiryTime);
    };
    const handleLogin = async () => {
        const { Company_Email, Profile_Password } = signup;
        if (!Company_Email || !Profile_Password) {
            message.error('Please fill in all the fields');
            return;
        }
        setloading(true);
        try {
            const response = await fetch('https://api.boompay.in/login-user', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(signup)
            });
            const data = await response.json();
            //console.log(data);
            if (response.status === 200) {
                message.success('Login successfully.');
                setloading(false);
                setsignup({
                    Company_Email: '',
                    Profile_Password: ''
                })
                saveToken(data.token);
                dispatch({ type: 'LOGIN', payload: data.token });
                window.location.href = '/home'
            } else if (response.status === 400) {
                message.error(data.message);
                setloading(false);
            } else if (response.status === 403) {
                message.info(data.message);
                setloading(false);
            } else {
                message.error('Login failed. Please try again later.');
                setloading(false);
            }
        } catch (error) {
            console.error('Error:', error);
            message.error('An error occurred. Please try again later.');
            setloading(false);
        }
    }
    const handleForgot = async () => {
        const { Company_Email, NewProfile_Password } = forgotinput;
        if (!Company_Email || !NewProfile_Password) {
            message.error('Please fill in all the fields');
            return;
        }
        setloading(true);
        try {
            const response = await fetch('https://api.boompay.in/forgot-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ Company_Email, NewProfile_Password })
            });
            const data = await response.json();
            //console.log(data);
            if (response.status === 200) {
                message.success('Forgot successfully');
                setloading(false);
                setforgotinput({
                    Company_Email: '',
                    NewProfile_Password: ''
                })
                setForgotmodal(false);
            } else if (response.status === 400) {
                message.error(data.message);
                setloading(false);
            } else if (response.status === 403) {
                message.info(data.message);
                setloading(false);
            } else {
                message.error('Login failed. Please try again later.');
                setloading(false);
            }
        } catch (error) {
            console.error('Error:', error);
            message.error('An error occurred. Please try again later.');
            setloading(false);
        }
    }
    return (
        <>
            <Container size={'md'} mt={'xl'} p={'md'}>
                <Paper radius="md" p="lg" withBorder {...PaperProps}>
                    <Text size="lg" fw={500} c="bright">
                        Welcome to BOOM Pay, {type}
                        <Group>
                            <Image src={Boompaylogo} alt='BOOM Pay' h={90} fit="contain" w="auto" />
                            <Paper withBorder p="md" radius="md">
                                <Group justify="apart">
                                    <div>
                                        <Text c="dimmed" tt="uppercase" fw={700} fz="xs" className="label">
                                            Email Support
                                        </Text>
                                        <Text fw={700} fz="xl">
                                            onboard@boompay.in
                                        </Text>
                                    </div>
                                    <ThemeIcon
                                        color="gray"
                                        variant="light"
                                        style={{
                                            color: 'var(--mantine-color-teal-6)',
                                        }}
                                        size={38}
                                        radius="md"
                                    >
                                        {/* <DiffIcon size={28} stroke={1.5} /> */}
                                        <IconMail size={28} stroke={1.5} />
                                    </ThemeIcon>
                                </Group>
                                {/* <Text c="dimmed" fz="sm" mt="md">
                                    <Text component="span" c={stat.diff > 0 ? 'teal' : 'red'} fw={700}>
                                        {stat.diff}%
                                    </Text>{' '}
                                    {stat.diff > 0 ? 'increase' : 'decrease'} compared to last month
                                </Text> */}

                            </Paper>
                            <Paper withBorder p="md" radius="md">
                                <Group justify="apart">
                                    <div>
                                        <Text c="dimmed" tt="uppercase" fw={700} fz="xs" className="label">
                                            Call Support
                                        </Text>
                                        <Text fw={700} fz="xl">
                                            +91 770-183-6668
                                        </Text>
                                    </div>
                                    <ThemeIcon
                                        color="gray"
                                        variant="light"
                                        style={{
                                            color: 'var(--mantine-color-teal-6)',
                                        }}
                                        size={38}
                                        radius="md"
                                    >
                                        {/* <DiffIcon size={28} stroke={1.5} /> */}
                                        <IconPhoneCall size={28} stroke={1.5} />
                                    </ThemeIcon>
                                </Group>
                                {/* <Text c="dimmed" fz="sm" mt="md">
                                    <Text component="span" c={stat.diff > 0 ? 'teal' : 'red'} fw={700}>
                                        {stat.diff}%
                                    </Text>{' '}
                                    {stat.diff > 0 ? 'increase' : 'decrease'} compared to last month
                                </Text> */}

                            </Paper>
                        </Group>
                    </Text>

                    {/* <Group grow mb="md" mt="md">
                    <GoogleButton radius="xl">Google</GoogleButton>
                    <TwitterButton radius="xl">Twitter</TwitterButton>
                </Group> */}

                    {/* <Divider
                        label="Or continue with email"
                        labelPosition="center"
                        my="lg"
                        styles={{ label: { color: 'var(--mantine-color-bright)', opacity: 0.85 } }}
                    /> */}

                    <Stack my="lg">
                        {type === 'register' ? (
                            <>
                                <TextInput
                                    required
                                    label="Authorized Person Name"
                                    placeholder="Your name"
                                    name="Authorized_Person_Name"
                                    value={signup.Authorized_Person_Name}
                                    onChange={handelChange}
                                    radius="md"
                                />
                                <TextInput
                                    required
                                    label="Authorized Mobile Number"
                                    placeholder="Your number"
                                    name="Authorized_Person_Mobile_Number"
                                    value={signup.Authorized_Person_Mobile_Number}
                                    onChange={handelChange}
                                    radius="md"
                                    maxLength={10}
                                />
                                <TextInput
                                    required
                                    label="Company Email"
                                    placeholder="hello@company.mail"
                                    name="Company_Email"
                                    value={signup.Company_Email}
                                    onChange={handelChange}
                                    radius="md"
                                />
                                <TextInput
                                    required
                                    label="Company Name"
                                    placeholder="Your company name"
                                    name="Company_Name"
                                    value={signup.Company_Name}
                                    onChange={handelChange}
                                    radius="md"
                                />
                                <PasswordInput
                                    required
                                    label="Create Password"
                                    placeholder="Your password"
                                    name="Profile_Password"
                                    value={signup.Profile_Password}
                                    onChange={handelChange}
                                    radius="md"
                                />
                            </>
                        )
                            :
                            (
                                <>
                                    <TextInput
                                        required
                                        label="Registered ID"
                                        placeholder="hello@company.mail"
                                        name="Company_Email"
                                        value={signup.Company_Email}
                                        onChange={handelChange}
                                        radius="md"
                                    />

                                    <PasswordInput
                                        required
                                        label="Registered Password"
                                        placeholder="Your password"
                                        name="Profile_Password"
                                        value={signup.Profile_Password}
                                        onChange={handelChange}
                                        radius="md"
                                    />
                                    <Group justify='flex-start'>
                                        <Button size='xs' variant='transparent' onClick={() => setForgotmodal(true)}>Forgot Password?</Button>
                                    </Group>
                                </>
                            )
                        }


                        {/* {type === 'register' && (
                            <Checkbox
                                label="I accept terms and conditions"
                            //checked={form.values.terms}
                            //onChange={(event) => form.setFieldValue('terms', event.currentTarget.checked)}
                            />
                        )} */}
                    </Stack>

                    <Group justify="space-between" mt="xl">
                        <Anchor
                            component="button"
                            type="button"
                            c="bright"
                            opacity={0.85}
                            onClick={() => toggle()}
                            size="xs"
                        >
                            {type === 'register'
                                ? 'Already have an account? Login'
                                : "Don't have an account? Register"}
                        </Anchor>
                        {
                            type === 'register' ? <Button radius="xl" onClick={handleSubmit} loading={loading}>
                                Submit for Verification
                            </Button> : <Button radius="xl" onClick={handleLogin} loading={loading}>
                                Login
                            </Button>
                        }
                    </Group>
                </Paper>
            </Container>
            <Modal
                opened={forgotmodal}
                onChange={() => setForgotmodal(true)}
                onClose={() => setForgotmodal(false)}
                title="Forgot password"
            >
                <Stack>
                    <>
                        <TextInput
                            required
                            label="Registered ID"
                            placeholder="hello@company.mail"
                            name="Company_Email"
                            value={forgotinput.Company_Email}
                            onChange={handelforgotChange}
                            radius="md"
                        />

                        <PasswordInput
                            required
                            label="Registered Password"
                            placeholder="Your password"
                            name="NewProfile_Password"
                            value={forgotinput.NewProfile_Password}
                            onChange={handelforgotChange}
                            radius="md"
                        />

                    </>
                </Stack>
                <Button radius="xl" onClick={handleForgot} loading={loading} mt={'xs'}>
                    Forgot Password
                </Button>
            </Modal>
        </>
    )
}

export default Signup;